import { render, staticRenderFns } from "./ChatbotManagement.vue?vue&type=template&id=c0941a8c&"
import script from "./ChatbotManagement.vue?vue&type=script&lang=js&"
export * from "./ChatbotManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotManagement.vue?vue&type=style&index=0&id=c0941a8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports